<template>
<q-list v-if="users.data.length" :bordered="$isDesktop" separator class="rounded-borders">
    <q-item v-for="user in users.data" :key="user.id" v-if="$isDesktop">
        <q-item-section>
            <div class="row">
                <div class="col-3">
                    <common-link :label="$fullName(user)"
                                 :href="$route('user.edit', { gebruiker: user.id, page:users.current_page })" />
                </div>
                <div class="col-1">
                    <q-icon v-if="user.two_factor_confirmed_at"
                            name="lock">
                        <q-tooltip>Twee-factor-authenticatie geactiveerd</q-tooltip>
                    </q-icon>
                </div>
                <div class="col-2">
                    {{ roles(user) }}
                </div>
                <div class="col">
                    {{ categories(user) }}
                </div>
            </div>
        </q-item-section>
        <q-item-section side top>
            <div class="row">
          <span class="q-mr-sm">
            {{ $formatDateString(user.created_at) }}
          </span>
            </div>
        </q-item-section>
    </q-item>
    <q-item v-else v-for="user in users.data" :key="user.id">
        <q-item-section>
            <q-item-label>
                <common-link :label="$fullName(user)"
                             :href="$route('user.edit', { gebruiker: user.id, page:users.current_page })" />
            </q-item-label>
            <q-item-label caption>{{ roles(user) }}</q-item-label>
        </q-item-section>
    </q-item>
</q-list>
</template>

<script>
export default {
    props: {
        users: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        roles (user) {
            if (user.roles.length === 0) {
                return '-'
            }

            const roles = user.roles.map((role) => role.name)

            return roles.join(', ')
        },
        categories (user) {
            if (user.categories.length === 0) {
                return '-'
            }

            const categories = user.categories.map((category) => category.title)

            return categories.join(', ')
        },
    },
}
</script>
